<template>
  <div class="coupon-card">
    <div class="card-left">
      <div v-if="couponInfo.discountType">
        <span>¥</span><b>{{ couponInfo.discountAmount }}</b>
      </div>
      <div v-else>
        <b>{{ couponInfo.discountAmount }}</b
        ><span>折</span>
      </div>
      <p>满{{ couponInfo.usableCondition }}可用</p>
    </div>
    <div class="card-right">
      <h2>{{ couponInfo.frontEndName }}</h2>
      <p>{{showType(couponInfo.productionFitType,couponInfo.packageFitType)}}</p>
      <div>
        <span>已领</span><b>{{ couponInfo.couponCirculation - couponInfo.couponNum }}</b>
      </div>
    </div>
    <div class="btn">
      <img v-if="couponInfo.flag" src="@/assets/img/productDetail/receive_success.png" />
      <button :class="{ active: receiveStatus }" v-else @click="toReceive(couponInfo)">
        {{ receiveStatus ? '不可领取' : '领取' }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      //   receiving: false,
    };
  },
  props: {
    couponInfo: {
      type: Object,
      default: () => {},
    },
    receiveStatus: {
      type: Boolean,
      default: false,
    },
  },

  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
     showType(type, status) {
      const typeMap = {
        1: '所有产品',
        2: '指定产品可用',
        3: '指定产品可用',
      };
      let text = typeMap[type] || '';
      if (status === 4) {
        text = type === 1 ? '所有产品' : '指定产品可用';
      } else if (status === 5) {
        text = '指定产品可用';
      }
      return text;
    },
    toReceive(data) {
      if (this.receiveStatus) return;
      this.$emit('sendReceive', { item: data, type: 2 });
    },
  },
};
</script>
<style scoped lang="scss">
.coupon-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 590px;
  height: 215px;
  margin: 0 auto 24px;
  background: url('../../../assets/img/newUser/coupon-bg.png') no-repeat;
  background-size: 100%;
}
.card-left {
  width: 200px;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 10px;
    span {
      color: #ff6c02;
      font-weight: 500;
      font-size: 28px;
    }
    b {
      color: #ff6c02;
      font-weight: 500;
      font-size: 48px;
    }
  }
  > p {
    color: #a5a5a5;
    font-size: 24px;
    text-align: center;
  }
}
.card-right {
  width: 360px;
  padding-left: 24px;
  > h2 {
    color: #333;
    font-size: 32px;
    @extend .ellipsis;
  }
  > p {
    padding: 16px 0;
    color: #a5a5a5;
    font-size: 24px;
  }
  > div {
    span {
      padding-right: 5px;
      color: #a5a5a5;
      font-size: 24px;
    }
    b {
      padding: 0 90px 0 0;
      color: #ff6c02;
      font-weight: 300;
      font-size: 24px;
    }
  }
}
.btn {
  position: absolute;
  right: 24px;
  bottom: 24px;
  button {
    min-width: 120px;
    height: 48px;
    color: #fff;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    background: #ff6c02;
    border-radius: 32px;
  }
  button.active {
    color: #eee;
    background: #a5a5a5;
  }
  > img {
    width: 118px;
  }
}
</style>
